import { render, staticRenderFns } from "./InvScI_List.vue?vue&type=template&id=47ea4bb8"
import script from "./InvScI_List.vue?vue&type=script&lang=js"
export * from "./InvScI_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports